module.exports = __webpack_public_path__ + "img/kia-white.cea0235d.png";